import { gateway } from "../../../gateway";

export const deleteKanbanCategory = async (uid: string) => {
    try {
        if (!uid) {
            throw new Error("Category UID is required");
        }
        await gateway.delete(`/kanban-categories/self/${uid}`);
    } catch (error: any) {
        console.log(error);
        throw new Error(error.response.data.message);
    }
};